
import React, { useEffect, useState } from "react";
import base from "./base.js";
import {Ellipsis } from 'react-spinners-css';
import { Spinner } from "react-spinners-css";
export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    base.auth().onAuthStateChanged((user) => {
      setCurrentUser(user)
      setPending(false)
    });
  }, []);

  if (pending) {
    return <div className="elipsis-padding-box">
          <Spinner color="grey"/>
      </div>;
  }
  return (
    <AuthContext.Provider
      value={{
        currentUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};